import * as React from 'react'
import { ClearAllButtonProps } from '../typings'
import { FilterClearButton } from './atoms'

export function ClearAllButton(props: ClearAllButtonProps) {
  const { clearAll } = props

  return (
    <FilterClearButton data-test-id="filters-clearAllBtn" onClick={clearAll}>
      Clear All
    </FilterClearButton>
  )
}
